import { useAppSelector } from "@store";
import { useEffect, useRef } from "react";
import type { TDesignSystemRoot } from "@/shared/types";
import { loadGoogleFontsForDesign, updateDesignSystemRoot } from "@/shared/utils";

// Re-applies design-system CSS variables + Google Fonts stylesheets when the
// design changes in Redux. The LOCAL dispatch path applies them imperatively
// inside handleDesignSystem, but REMOTE changes land via syncFromYjs, which
// only writes Redux state — without this bridge a peer's colors/fonts never
// reach the DOM until reload. The fingerprint guard skips the no-op re-renders
// every reconcile produces (syncFromYjs rebuilds the settings object), and the
// local echo (same fingerprint applied twice) is idempotent.
export const DesignSystemSyncBridge = () => {
  const design = useAppSelector(
    (state) => state.story.story?.settings?.designSystemV2,
  );
  const lastApplied = useRef<string>("");

  useEffect(() => {
    if (!design) return;
    const fingerprint = JSON.stringify(design);
    if (fingerprint === lastApplied.current) return;
    lastApplied.current = fingerprint;
    loadGoogleFontsForDesign(design as Record<string, unknown>);
    updateDesignSystemRoot(design as unknown as TDesignSystemRoot);
  }, [design]);

  return null;
};
